import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { useState, useEffect } from 'react';
import { updateData } from '../../../services';
import Modal from '../../helpers/Modal';
export const EditFreightForm = ({ project }) => {
    const { token, base_url, setProjects } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [formData, setFormData] = useState({
        freight_carrier: '',
        tracking_number: ''
    });

    useEffect(() => {
        setFormData({
            freight_carrier: project.freight_carrier || '',
            tracking_number: project.tracking_number || ''
        });
    }, [project]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const updated_project = await updateData(token, `${base_url}/apis/projects/${project.id}`, {
                freight_carrier: formData.freight_carrier,
                tracking_number: formData.tracking_number
            });

            if (updated_project.project) {
                setProjects(prevProjects =>
                    prevProjects.map(p =>
                        p.id === project.id ? updated_project.project : p
                    )
                );
                window.showAlert(200, 'Freight info updated successfully!');
            }

            setIsModalOpen(false);
        } catch (error) {
            console.error('Error updating freight info:', error);
            if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Invalid data. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to update freight info. Please try again.');
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const form = (
        <div>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="freight_carrier" className="form-label">
                        Freight Carrier
                    </label>
                    <select
                        id="freight_carrier"
                        name="freight_carrier"
                        value={formData.freight_carrier}
                        onChange={handleChange}
                        className="form-input"
                    >
                        <option value="">Select a carrier</option>
                        <option value="saia">Saia</option>
                        <option value="fedex">Fedex</option>
                        <option value="old dominion">Old Dominion</option>
                        <option value="volume">Volume</option>
                        <option value="pickup from shop">Pickup from Shop</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="tracking_number" className="form-label">
                        Tracking Number
                    </label>
                    <input
                        type="text"
                        id="tracking_number"
                        name="tracking_number"
                        value={formData.tracking_number}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Enter tracking number"
                    />
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                        className="btn btn-secondary"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <div>
            <button className="edit-address-button btn btn-action" onClick={() => setIsModalOpen(true)} title="Edit freight info">
                <FontAwesomeIcon icon={faPen} />
            </button>
            {isModalOpen && (
                <Modal form={form} setIsModalOpen={setIsModalOpen} />
            )}
        </div>
    );
};
